import { useQuery } from "react-query";
import { VFile } from "../file/VFile";
import { LinkShare } from "../share/Share";

export const useShareLink = (params: { share: LinkShare; file: VFile }) =>
  useQuery(["share_link", params.share.id], () => params.share.link(params.file));
